import api from '@/services/careers/service';
import {
  getCareersResponse,
  getCareerByIdResponse
} from '@/services/careers/response';
import * as types from './mutation-types';
import handleErrors from '@/utils/handler-errors';
import * as messages from '@/utils/error-messages';

export function getCareers({ commit, state }) {
  api.getCareers().then((response) => {
    const dataResponse = getCareersResponse(response);
    commit(types.CAREERS, dataResponse);
  }).catch(() => {
    handleErrors(messages.MESSAGE_1);
  });
}

export function getCareerById({ commit, state }, response) {
  const dataResponse = getCareerByIdResponse(response);
  commit(types.CAREER, dataResponse);
}

export default {
  getCareers,
  getCareerById
};



// WEBPACK FOOTER //
// src/store/modules/careers/actions.js